import { render, staticRenderFns } from "./RankdeaIntegral.vue?vue&type=template&id=9ce8e072&scoped=true"
import script from "./RankdeaIntegral.vue?vue&type=script&lang=js"
export * from "./RankdeaIntegral.vue?vue&type=script&lang=js"
import style0 from "./RankdeaIntegral.vue?vue&type=style&index=0&id=9ce8e072&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce8e072",
  null
  
)

export default component.exports